// extracted by mini-css-extract-plugin
export default {"container":"CardsContainerForBalances_module_container__KCS50"};